(() => {
  if (customElements.get('cc-studio-artwork')) return;
  class CCStudioArtwork extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const input = this.querySelector('input[type="file"]');
      const status = this.querySelector('.cc-studio-artwork__status');
      if (!input || !status) return;
      const validate = () => {
        const file = input.files?.[0];
        input.setCustomValidity('');
        if (!file) { status.textContent = ''; return; }
        const supported = /\.(ai|svg|pdf|png|jpe?g|heic|webp)$/i.test(file.name);
        const error = !supported ? 'Please choose an AI, SVG, PDF, PNG or supported image file.' : file.size > 10 * 1024 * 1024 ? 'This file exceeds 10 MB. Please use a smaller file or share a viewable file link in Notes.' : '';
        input.setCustomValidity(error);
        status.textContent = error || `${file.name} selected. It will be attached when you add this item to your cart.`;
        status.style.color = error ? '#9b2828' : 'inherit';
      };
      input.addEventListener('change', validate);
      this.addEventListener('dragover', event => { event.preventDefault(); this.dataset.dragging = 'true'; });
      this.addEventListener('dragleave', event => { if (!this.contains(event.relatedTarget)) delete this.dataset.dragging; });
      this.addEventListener('drop', event => {
        event.preventDefault();
        delete this.dataset.dragging;
        const file = event.dataTransfer?.files?.[0];
        if (!file) return;
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
  customElements.define('cc-studio-artwork', CCStudioArtwork);
})();
